
import WidgetNuxtNode from './widget-nuxt-node.vue';
export default {
  name: 'WidgetNuxtWrapper',
  functional: true,
  render(h, ctx) {
    const {
      widgetId,
      file,
      widgetApi,
      tree,
      dataInject: baseDataInject,
      idSuffix,
      getCache,
      setCache,
    } = ctx.props;
    let components = ctx.parent.$options.components;

    const createVNode = (id, obj) => {
      let node = tree[id];
      if (!node) return;
      const { type, children, dataSource } = node;
      const dataInject = obj.dataInject;
      let name = `${type}Nuxt`;
      if (!components[name]) name = 'WidgetDefaultNuxt';
      if (dataSource && id !== widgetId) {
        return h('WidgetNuxt', {
          props: { widgetId: id, dataInject, tree, file },
          class: obj.class,
        });
      }

      const cache = getCache();
      const $bus = widgetApi.$bus;
      let childNodes = [];
      let isLeaf = !children?.length;
      let idSuffix = obj.idSuffix || [];
      let idFull = id + idSuffix.join('-');
      let needCache = !!dataSource;
      let classes = [id, 'widget'];
      if (obj.class) {
        classes = classes.concat(obj.class);
      }

      let data = {
        props: {
          id: idFull,
          nodeId: id,
          file,
          widgetApi,
          dataInject,
          widgetType: name,
        },
        key: idFull,
        class: classes,
      };

      if (!isLeaf) {
        let l = children.length;
        let start = 0;
        let index = Object.keys(dataInject).length; // index: 列表层级
        if (dataSource) {
          let page = ~~dataSource.page;
          let limit = ~~dataSource.limit;
          start = page * limit;
        }

        for (let i = 0; i < l; i++) {
          let opt = { ...obj };
          let j = children[i];
          if (dataSource) {
            let path = i + start; // 索引
            opt = {
              idSuffix: [...idSuffix, path],
              dataInject: {
                ...dataInject,
                [id]: { id, path, index, ...dataSource },
              },
            };
          }
          let o;
          opt.class = [];
          if (needCache && cache[i]) {
            o = cache[i];
          } else {
            if (type === 'WidgetCarousel') {
              opt.class = ['swiper-slide'];
            }
            o = createVNode(j, opt);
            if (needCache) setCache(i, o);
          }
          childNodes.push(o);
          let event = 'rocket:system:infinite-scroll:' + j;
          if ($bus._events[event] !== undefined) {
            childNodes.push(
              h(components.ScrollObserver, {
                on: {
                  intersection: () =>
                    widgetApi.$bus.$emit(event, {
                      dataInject: opt.dataInject,
                    }),
                },
              })
            );
          }
        }
      }
      const vNode = h(WidgetNuxtNode, data, childNodes);
      return vNode;
    };
    let result = createVNode(widgetId, {
      dataInject: baseDataInject,
      idSuffix,
    });
    return result;
  },
};
